<script>
import { GlModal, GlSafeHtmlDirective as SafeHtml } from '@gitlab/ui';
import { uniqueId } from 'lodash-es';
import PURCHASE_SUCCESS_SVG from '~/images/purchase-success-md.svg';

export default {
  name: 'PurchaseSuccessModal',
  PURCHASE_SUCCESS_SVG,
  safeHtmlConfig: {
    ADD_ATTR: ['target'],
  } /* https://gitlab.com/gitlab-org/gitlab-ui/-/issues/1427 */,
  components: {
    GlModal,
  },
  directives: {
    SafeHtml,
  },
  props: {
    description: {
      type: String,
      required: false,
      default: '',
    },
    visible: {
      type: Boolean,
      required: true,
    },
    actionPrimary: {
      type: Object,
      required: false,
      default: null,
    },
    successRedirectPath: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: 'Thank you!',
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      modalId: uniqueId('purchase-success-modal'),
    };
  },
  methods: {
    acceptModal() {
      window.location.href = this.successRedirectPath;
    },
  },
};
</script>

<template>
  <gl-modal
    ref="modal"
    modal-class="purchase-success-modal"
    :aria-label="title"
    :modal-id="modalId"
    size="sm"
    :visible="visible"
    no-fade
    hide-header
    :hide-footer="hideFooter"
    v-bind="{ actionPrimary }"
    @hide="acceptModal"
  >
    <img
      :src="$options.PURCHASE_SUCCESS_SVG"
      class="gl-m-auto gl-mb-6 gl-block"
      alt="Thank you for your purchase"
    />
    <div :class="['gl-text-center', { 'gl-mb-6': !hideFooter }]">
      <h2 class="gl-mb-4 gl-mt-6 gl-font-bold">{{ title }}</h2>
      <slot></slot>
      <p v-if="description" v-safe-html:[$options.safeHtmlConfig]="description"></p>
    </div>
  </gl-modal>
</template>
